import './artgalleryontario/style';
import FormStructure from './artgalleryontario/form_structure';

export default FormStructure;